import { useState, useEffect } from 'react';
import {
  useMediaQuery,
  Button,
  Dialog,
  DialogContent,
  Box,
  Typography,
} from '@mui/material';
import AdvisoryCloudLogo from './../../../AdvisoryCloudLogo';
import { useAccount } from '../../../../contexts/Account';
import eventBus, { eventBusValues } from '../../../../eventBus';


const useStyles = ({ isXS }) => ({
  floatingButton: {
    bottom: '20px',
    left: '50%',
    width: '400px',
    transform: 'translateX(-50%)',
    height: '36px',
    fontSize: '15px',
  },
  stickyButton: {
    bottom: 0,
    left: 0,
    width: '100%',
    textAlign: 'center',
    borderRadius: '0px',
    height: '44px',
    fontSize: '16px',
    margin: '0 auto',
    transform: 'translateX(0)',
  },
  dialogPaper: {
    borderRadius: '8px',
    maxWidth: '882px',
    paddingBottom: "30px"
  },
  logoBox: {
    textAlign: 'center',
    paddingTop: '24px',
    paddingBottom: isXS ? 0 : '26px',
  },
  title: {
    fontWeight: 500,
    fontSize: '20px',
    textAlign: 'center',
    marginBottom: '4px',
    letterSpacing: '0.75px',
    lineHeight: '24px',
    marginBottom: '30px'
  },
  fieldGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    width: '100%',
    marginBottom: '16px',
  },
  label: {
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0.75px',
    marginBottom: '0px',
    display: 'block',
    width: '350px',
  },
  submitButton: {
    marginTop: '24px',
    marginBottom: '16px',
    width: isXS ? '90%' : '330px',
    height: '53px',
    textTransform: 'none',
    fontSize: '16px',
    borderRadius: '10px',
    display: 'flex',
    mx: 'auto',
    weight: 600,
    fontSize: '20px',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  scheduleOnceContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
  },
});

function SuggestionRateButton() {
  const { isFreemium } = useAccount();
  const isXXS = useMediaQuery((theme) => theme.breakpoints.down('xxs'));
  const isXS = useMediaQuery((theme) => theme.breakpoints.down('xs'));
  const isSM = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const isMD = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const isLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const isXL = useMediaQuery((theme) => theme.breakpoints.down('xl'));
  const classes = useStyles({ isXS });
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    if (isFreemium) {
      eventBus.dispatch(eventBusValues.triggerAdvisorUpgradeAction, {
        origin: 'get-advisor-rate-suggestions',
      });
    } else {
      setOpen(true);
    }
  };
  const handleClose = () => setOpen(false);

  useEffect(() => {
    setTimeout(() => {
      const widget = document.createElement('script');
      widget.type = 'text/javascript';
      widget.src = 'https://cdn.oncehub.com/mergedjs/so.js';
      const container = document.getElementById('SOIDIV_accheckincall');
      if (container) {
        container.appendChild(widget);
      }
    }, 0);

    return () => {
      const scheduleOnceScript = document.getElementById(
        'SOIDIV_accheckincall'
      );
      if (scheduleOnceScript) {
        scheduleOnceScript.parentNode?.removeChild(scheduleOnceScript);
      }
    };
  }, [open]);

  return (
    <>
      <Box
        sx={{
          position: 'fixed',
          bottom: '0px',
          left: '0px',
          width: isXXS
            ? '100%'
            : isXS
            ? '100%'
            : isSM
            ? '100%'
            : isMD
            ? '80%'
            : isLG
            ? '80%'
            : isXL
            ? '70%'
            : '60%',
        }}
      >
        <Button
          variant="contained"
          color="primary"
          fullWidth={isXS}
          id="get-advisor-rate-suggestions"
          sx={{
            position: 'absolute',
            bottom: '20px',
            left: '50%',
            transform: 'translateX(-50%)',
            width: isXS ? '100%' : '330px',
            fontWeight: 600,
            ...(isXS ? classes.stickyButton : {}),
          }}
          onClick={handleClick}
        >
          Get Advisor Rate Suggestions
        </Button>
      </Box>

      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="sm"
        PaperProps={{ sx: classes.dialogPaper }}
      >
        <Box sx={classes.logoBox}>
          <AdvisoryCloudLogo
            removeHyperlink
            onClick={() => {}}
            width={190}
            height={34}
          />
        </Box>

        <DialogContent sx={{ p: isXS ? '10px' : '0px 80px' }}>
          <Typography sx={classes.title}>
            Let our team provide suggestions for your Advisor Rate.
          </Typography>
          <Box sx={{ maxWidth: 900, mx: 'auto', px: 2 }}>
            <div
              id="SOIDIV_accheckincall"
              data-so-page="accheckincall"
              data-height="550"
              data-style="border: 1px solid #d8d8d8; min-width: 290px; max-width: 900px;"
              data-psz="00"
            />
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default SuggestionRateButton;
